import React from 'react';
import { styled } from 'styled-components';
import colors from '../styles/colors';

interface StickyFooterProps {
  children: React.ReactNode;
}

const FooterContainer = styled.div<{ $childCount: number }>`
  max-width: 906px;
  position: sticky;
  bottom: 0;
  background-color: ${colors.neutral.white};
  border-top: 1px solid ${colors.neutral.grey200};
  padding: 1.5rem 0;
  text-align: center;
  margin-top: auto;
  display: flex;
  justify-content: ${(props) =>
    props.$childCount === 1 ? 'center' : 'space-between'};
  gap: ${(props) => (props.$childCount > 1 ? '1rem' : '0')};
  z-index: 300;

  & > * {
    flex: ${(props) => (props.$childCount === 1 ? '1' : 'auto')};
    width: ${(props) => (props.$childCount === 1 ? '100%' : 'auto')};
  }
`;

const StickyFooter: React.FC<StickyFooterProps> = ({ children }) => {
  const childArray = React.Children.toArray(children);
  const childCount = childArray.length;

  return <FooterContainer $childCount={childCount}>{children}</FooterContainer>;
};

export default StickyFooter;
